import { createFileRoute, defer } from '@tanstack/react-router';
import {
    contactsGroupItemsQueryOptions,
    contactsGroupQueryOptions,
} from '@utils/queryOptions';
import ContactsGroupDetails from '@Views/Contacts/groups/details';

export const Route = createFileRoute('/contacts/groups/$groupId')({
    component: ContactsGroupDetails,
    loader: opts => {
        const { groupId } = opts.params;
        opts.context.queryClient.ensureQueryData(
            contactsGroupQueryOptions(groupId),
        );

        defer(
            opts.context.queryClient.ensureQueryData(
                contactsGroupItemsQueryOptions(groupId, opts.deps),
            ),
        );
    },
    loaderDeps: ({ search }) => search,
});
